import React, {useEffect, useState} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Tabs, Table, notification } from 'antd';
import moment from 'moment';
import { googleLogout } from '@react-oauth/google';
const { TabPane } = Tabs;

function Dashboard() {
	// const myParam = window.location.search;
    const history = useNavigate();
    // var productId= new URLSearchParams(myParam).get("id");
    const [loading, setLoading] = useState(false);
	const [mobile, setMobile] = useState(false);
    const [bookings, setBookings] = useState({});
	const [user, setUser] = useState({});
    const [totalBookings, setTotalBookings] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pagination, setPagination] = useState(0);

	const [inputs, setInputs] = useState({});
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        console.log(value)
        setInputs(values => ({...values, [name]: value}))
    }

	const columns = [
		{
		  title: 'Space Name',
		  dataIndex: 'name',
		  render: text => <a className='text-[#439764] text-base font-medium' href={window.location.host+'/home?id='+text.id}>{text.name}</a>,
		},
		{
		  title: 'Price',
		  dataIndex: 'amount',
		  defaultSortOrder: 'descend',
		  sorter: (a, b) => a.amount - b.amount,
		  render: text => <span className='text-base font-normal text-[#393A4A]'>N{text}</span>,
		},
		{
			title: 'Viewing Date',
			dataIndex: 'date',
			defaultSortOrder: 'descend',
			sorter: (a, b) => a.date.localeCompare(b.date),
			render: text => <span className='text-base font-normal text-[#393A4A]'>{text}</span>,
		},
		{
			title: 'Viewing Time',
			dataIndex: 'time',
			defaultSortOrder: 'descend',
			sorter: (a, b) => a.time.localeCompare(b.time),
			render: text => <span className='text-base font-normal text-[#393A4A]'>{text}</span>,
		},
		{
			title: 'Actions',
			dataIndex: '',
			key: 'x',
			render: () => <a className='text-[#439764]! text-base font-medium '>Apply Now</a>,
		},
	];
	  
	const data = [
		{
		  key: '1',
		  name: {id: 973, name: 'SHARED APARTMENT IN ROCK STONE ESTATE BADORE'},
		  amount: 400000,
		  date: '12th of June',
		  time: '12:20pm'
		},
		{
		  key: '2',
		  name: {id: 973, name: 'SHARED APARTMENT IN ROCK STONE ESTATE BADORE'},
		  amount: 800000,
		  date: '12th of June',
		  time: '12:20pm'
		},
		{
		  key: '3',
		  name: {id: 973, name: 'SHARED APARTMENT IN ROCK STONE ESTATE BADORE'},
		  amount: 750000,
		  date: '13th of June',
		  time: '1:30pm'
		},
		{
		  key: '4',
		  name: {id: 973, name: 'SHARED APARTMENT IN ROCK STONE ESTATE BADORE'},
		  amount: 850000,
		  date: '15th of June',
		  time: '9:00am'
		},
	];
	  
	function onChange(pagination, filters, sorter, extra) {
	console.log('params', pagination, filters, sorter, extra);
	}
	// let mobile = false
	
	
	// 
	const goTo = (place) => {
		window.location.href=window.location.host+'/home?id='+place
	}

	useEffect(() => {
		if (window.screen.width < 708){
			// mobile = true
			setMobile(true)
			// console.log("yes")
		}
		
        const loadPost = async () => {
            setLoading(true);

            try{
              var user = JSON.parse(localStorage.user).user;
			  var userProfile = JSON.parse(localStorage.user).profile;
			  console.log(user, userProfile)
			  setUser(userProfile)
              console.log(user)
            } catch(e){
                user = false 
            }

            if (!user){
              notification.open({
                  message: 'Please Log In',
                  description:
                    '',
                  onClick: () => {
                    console.log('Notification Clicked!');
                  },
                });
              history("/login"); 
            } else{

              const response = await axios.get(
              "https://api.bubble.africa/users/bookings/all/"+user.id+"?page=1").then((res)=>{
				const viewings = []
				for (let view of res.data.houses){
					const name = view.name
					const date = view.bookingDate
					const amount = view.amount
					view.name = {
						name: name,
						id: view.id
					}
					view.date = moment(date).format("LL")
					view.time = moment(date).format("LT")
					view.amount = amount.toLocaleString()
					view.key = view.id
					viewings.push(view)
				}
                setBookings(viewings);
                setTotalBookings(res.data.total)
                //   setPagination(res.data.records_per_page)
                //   setCurrentPage(Number(page))
                console.log(res)
              }).catch(()=>{
                  console.log("try")
              });
              
            }
            setLoading(false);
        }
        loadPost();
    },[]);

	const handleSubmit = async (event) => {
        // if (!this.validate()) { event.preventDefault() }
        event.preventDefault();
		
        console.log(inputs);
		try{
			var user = JSON.parse(localStorage.user).user;
			var userProfile = JSON.parse(localStorage.user).profile;
			var token = JSON.parse(localStorage.user).token;
		  } catch(e){
			  user = false 
		  }

		  if (!user){
			notification.open({
				message: 'Please Log In',
				description:
				  '',
				onClick: () => {
				  console.log('Notification Clicked!');
				},
			  });
			history("/login"); 
		  } else{
			const newPhone = inputs.phone || userProfile.phone
			const newFirstName = inputs.firstName || userProfile.first_name
			const newLastName = inputs.lastName || userProfile.last_name
		await axios.post('https://api.bubble.africa/users/userprofile/create/'+user.id, {
			first_name: newFirstName,
			last_name: newLastName,
			phone: newPhone,
			email: userProfile.email,
			facebook: null,
			bio: null,
			twitter: null,
			instagram: null,
			occupation: null,
			smoking: null,
			religion: null,
			pets: null,
			location: null,
			interests: null,
		}, {headers: { 'Content-Type': 'application/json' }})
            .then((res) => {
				userProfile.first_name = newFirstName
				userProfile.last_name = newLastName
				userProfile.phone = newPhone
				// console.log
				let newDetails = {
					user,
					token,
					profile: userProfile
				}
				localStorage.setItem('user', JSON.stringify(newDetails));
				notification.open({
					message: 'User Profile Updated',
					description:
					  '',
					onClick: () => {
					  console.log('Notification Clicked!');
					},
				  });
				window.location.href='/dashboard';
				
            }).catch((error) => {
                console.log(error, inputs);
				notification.open({
					message: 'Please Try Again',
					description:
					  '',
					onClick: () => {
					  console.log('Notification Clicked!');
					},
				  });
				
            });
		}
    }
	return (
		<>
		{loading ? (
					  <>
					  <img alt='Loader' width ='100%' src='./images/loader.png' />
					  </>
					) :
				    (
					<>
					<div className='container'>
					<br/>
					<p className='cg text-[28px] leading-9 lg:text-[38px] font-bold text-[#0B1911] py-10'>Dashboard</p>
					
					<Tabs defaultActiveKey="1" >
						<TabPane tab="Viewings" key="1">
						{bookings.length > 0 ? (
							
								(mobile ? 
								(
									
									bookings.map((viewings) => (
										<div className='p-6 rounded-md border border-[#C2C2C2] flex flex-col gap-8 mb-4'>
											<p className='text-[#439764] text-base font-normal' onClick={goTo(viewings.name.id)}>{viewings.name.name}</p>
											<div className='flex flex-row'>
												<div className='w-1/2'>
													<p className='font-normal text-base text-[#214B32]'>Viewing Date</p>
													<span className='font-normal text-base text-[#6B8776]'>{viewings.date}</span>
												</div>
												<div className='w-1/2'>
													<p className='font-normal text-base text-[#214B32]'>Viewing Time</p>
													<span className='font-normal text-base text-[#6B8776]'>{viewings.time}</span>
												</div>
											</div>

											<div className='flex flex-row'>
												<div className='w-1/2'>
													<p className='font-normal text-base text-[#214B32]'>Price</p>
													<span className='font-normal text-base text-[#6B8776]'>N{viewings.amount.toLocaleString()}</span>
												</div>
												<div className='w-1/2'>
												<a className='block w-[103px] h-12 rounded-xl bg-[#64E296] text-[#214B32] text-center py-[12px] text-base' onClick={() =>{ 
													console.log("lol"); 
												}}>Apply Now</a>
												</div>
											</div>

										</div>
									))
								) 
								: 
								(
									<Table columns={columns} dataSource={bookings} onChange={onChange} />
								)
							
						)) : (
							<>
								<center>
									<img className='no-booking' src='./images/empty.png' alt='no booking'/>
										
									<br/><br/>
										<p>You don't have any bookings yet</p>
									<br/><br/><br/>
									<span>
										<a href="#API">Find a home now {'>'}</a>
									</span>
								</center>
							</>
						)}
							
						</TabPane>
						<TabPane tab="Profile" key="2">
							<form className="w-full max-w-[640px] pt:10 lg:pt-[70px] mx-auto" onSubmit={handleSubmit}>
								<div className="flex flex-wrap -mx-3 mb-1 lg:mb-6">
									<div className="w-full md:w-1/2 px-3 mb-1 lg:mb-6 md:mb-0">
									<label className="block  tracking-wide text-[#214B32] text-lg font-medium mb-2" for="grid-first-name">
										First Name
									</label>
									<input className="appearance-none block w-full bg-[#F2F2F2] rounded-xl text-gray-700 border-2 border-[#828282] py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white h-12" id="grid-first-name" type="text" placeholder="Enter your name" name="firstName" value={inputs.firstName ? inputs.firstName : user.first_name} onChange={handleChange} />
									
									</div>
									<div className="w-full md:w-1/2 px-3 mb-1 lg:mb-6 md:mb-0">
									<label className="block  tracking-wide text-[#214B32] text-lg font-medium mb-2" for="grid-first-name">
										Last Name
									</label>
									<input className="appearance-none block w-full bg-[#F2F2F2] rounded-xl text-gray-700 border-2 border-[#828282] py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white h-12" id="grid-first-name" type="text" placeholder="Enter your name"name="lastName"   value={inputs.lastName ? inputs.lastName : user.last_name} onChange={handleChange} />
									
									</div>
									
								</div>
								<div className="flex flex-wrap -mx-3 mb-10">
									<div className="w-full md:w-1/2 px-3">
									<label className="block tracking-wide text-[#214B32] text-lg font-medium mb-2" for="grid-phone">
										Phone Number
									</label>
									<input className="appearance-none block w-full bg-[#F2F2F2] rounded-xl text-gray-700 border-2 border-[#828282] py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12" id="grid-phone" type="text" placeholder="+234" name="phone"  value={inputs.phone ? inputs.phone : user.phone} onChange={handleChange} />
									</div>

									<div className="w-full md:w-1/2 px-3">
									<label className="block tracking-wide text-[#214B32] text-lg font-medium mb-2" for="grid-email">
										Email
									</label>
									<input className="appearance-none block w-full bg-[#F2F2F2] rounded-xl text-gray-700 border-2 border-[#828282] py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12" id="grid-email" type="email" placeholder="Enter your email" name="email"  value={inputs.email ? inputs.email : user.email} onChange={handleChange} />
									</div>
								</div>

								<a className='phone:float-left lg:float-right block w-[103px] h-12 rounded-xl bg-[#64E296] text-[#214B32] text-center py-[12px] text-base' 
								type='submit'
								onClick={(e) =>{ 
									handleSubmit(e)
								}}
								>Submit</a>
							</form>
						</TabPane>
					</Tabs> 
					<br/><br/><br/>
					</div>
					</>
					)
		}
		</>
	)
	
}

export default Dashboard